import { mediaAPI } from '@/providers/apis/media/media';
import { PERMISSION_CHECK } from '@/utils/constants';
import { Vue, Component, Provide, Prop } from 'vue-property-decorator';
import RegistryFormFields from '../registry-form-field';
import { sessionService } from '@/providers/services/auth/session';
import FieldRender from '@/components/learing-registry/field-render/field-render';
import { isEmptyValue } from '@/utils/utils';

@Component({
    name: 'create-product-form',
    components: {
        'field-render': FieldRender,
    },
})

export default class CreateProductForm extends Vue {

    // Merge ContentRegistry and toolDetails
    private get formSections() {
        const toolDetails = this.formInstance.toolDetails;
        const propBind = toolDetails.partner.propBind;
        propBind.options = this.toolPartners;
        const productDetails = this.formInstance.contentRegistry;
        return [
            {
                name: 'Product Info',
                formData: Object.assign(toolDetails, productDetails),
            },
            {
                name: 'Subject and Grades',
                formData: this.formInstance.categoryInfo,
            },
        ];
    }

    @Provide('validator') public $validator: any = this.$validator;

    private productInfo = {
        0: ['name', 'thumbnail'],
        1: ['description'],
        2: ['contentURL'],
        3: ['partner', 'contentType', 'audience'],
    };

    private subcatInfo = {
        0: ['category', 'subject'],
        1: ['grades'],
    };

    // ----------------------------------------------------------------------------
    // Properties

    private formInstance = new RegistryFormFields();

    private submitted: boolean = false;

    @Prop()
    private toolPartners: any;

    @Prop()
    private activeToolData: any;

    private categoryInfo: any = [];

    private permissonCheck = PERMISSION_CHECK;

    private isLoading: boolean = false;

    private get isEditView() {
        return !!this.activeToolData;
    }

    private get isSuperAdmin() {
        return sessionService.isSuperAdminUser();
    }

    /**
     * Initiate default value in toolData objects
     */
    private toolData: any = {
        contentType: 'premium',
    };

    // ---------------------------------------------------------------------------
    // Hooks

    private created() {
        this.loadData();
        this.loadClassificationSubjects();
    }

    // -----------------------------------------------------------------------------
    // Actions

    private onAdd() {
        if (!this.isSuperAdmin && this.isEditView) {
            return;
        }
        this.submitted = true;
        this.$validator.validateAll().then((valid: any) => {
            if (valid) {
                this.isLoading = true;
                this.uploadThumbnail(this.toolData).then((fileName: any) => {
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 1000);
                    this.$emit('onAddPublisher', this.toolData);
                });
            }
        });
    }

    // --------------------------------------------------------------------------
    // Methods

    private setPartnersList() {
        const toolDetails = this.formInstance.toolDetails;
        const propBind = toolDetails.partner.propBind;
        propBind.options = this.toolPartners;
    }


    private uploadThumbnail(payload: any) {
        if (!isEmptyValue(payload.thumbnail) && typeof (payload.thumbnail) !== 'string'
        && payload.thumbnail instanceof File) {
            return mediaAPI.uploadFile(payload.thumbnail, 'image').then((fileData) => {
                return this.$set(this.toolData, 'thumbnail', fileData.filename);
            });
        }
        return Promise.resolve(payload.thumbnail);
    }

    private loadData() {
        this.setPartnersList();
        if (this.activeToolData) {
            this.toolData = this.activeToolData;
        }
    }

    private loadClassificationSubjects() {
        const toolData = this.activeToolData;
        if (toolData) {
            const {subject, category} = toolData;
            if (category) {
                this.formInstance.getSubjectList(category);
            }
            if (subject) {
                this.formInstance.onChangeSubject(subject);
            }
        }
    }



}
